import { LogService } from 'library/ts/utilities/logger/LogService';
export const debounce = (func, wait, immediate = false) => {
    let timeout;
    return function (...args) {
        const later = () => {
            timeout = null;
            if (!immediate)
                func.apply(this, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow)
            func.apply(this, args);
    };
};
export class Throttler {
    #lastExecutionTime = 0;
    #throttleInterval;
    constructor(interval = 200) {
        this.#throttleInterval = interval;
    }
    canExecute = () => {
        const currentTime = Date.now();
        const timeSinceLastExecution = currentTime - this.#lastExecutionTime;
        if (timeSinceLastExecution >= this.#throttleInterval) {
            this.#lastExecutionTime = currentTime;
            return true;
        }
        LogService.create({ prefixes: ['SmartTag:', 'throttler'] }).warn('execution prevented because ', 'timeSinceLastExecution (', timeSinceLastExecution, ')', 'is less than ', 'this.#throttleInterval (', this.#throttleInterval, ')');
        return false;
    };
}
export const runPromiseArray = (tasks) => {
    const results = [];
    const logger = LogService.create({ prefixes: ['SmartTag:', 'Utilities.Function.runPromiseArray'] });
    return new Promise((resolve, reject) => {
        const execute = (tasks) => {
            logger.log('execute:', 'tasks:', tasks);
            if (tasks && tasks.length > 0) {
                const task = tasks.shift();
                return task()
                    .then((output) => {
                    logger.log('execute:', 'task:', output);
                    results.push(output);
                    execute(tasks);
                })
                    .catch((error) => {
                    logger.warn(error);
                    results.push(error);
                    execute(tasks);
                });
            }
            logger.log('execute:', 'no tasks left...');
            resolve(results);
        };
        execute(tasks);
    });
};
